import { render, staticRenderFns } from "./WarrantyTracingForm.vue?vue&type=template&id=4c6fa72d"
import script from "./WarrantyTracingForm.vue?vue&type=script&lang=js"
export * from "./WarrantyTracingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports